import { useState, useContext, useReducer, useEffect } from "react";
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";

const urlIncidencias = process.env.REACT_APP_PGI_API + "/Incidence";
const urlIncidenciaGeneral = process.env.REACT_APP_PGI_API + "/General";
const urlIncidenciaProcesos = process.env.REACT_APP_PGI_API + "/Processes";
const urlIncidenciaSeguimiento = process.env.REACT_APP_PGI_API + "/Tracing";
const urlIncidenciasXproject = process.env.REACT_APP_XPROJECT_API + "/Incidence"
export const useIncidencia = () => {
    const { stateUser } = useContext(UserContext);
    const incidenciaDefault = {
        uidAccion: "",
        tituloIncidencia: "",
        descripcionIncidencia: "",
        codProductoInterno: 0,
        codEmpresaGeneral: 0,
        codUnidad: 0,
        padronUnidad: "",
        placaUnidad: "",
        codAreaDestino: 0,
        codIncidenciaConcepto: 0,
        codUrgencia: 0,
        solucionado: false,
        codIncidenciaTipoCierre: 0,
        comentarioSolucion: "",
    }

    const detalleDefault = {
        tituloIncidencia: "",
        descripcionIncidencia: "",
        codProductoInterno: 0,
        nomProductoInterno: "",
        padronUnidad: "",
        placaUnidad: "",
        codEmpresaGeneral: 0,
        nomEmpresa: "",
        uidCreacion: "",
        fechaHoraCreacion: "",
        codIncidenciaConcepto: 0,
        nomIncidenciaConcepto: "",
        versionEnquipo: "",
        modeloEquipo: "",
        vigenciaEquipo: "",
        nroOrdenActual: ""
    }

    const validarIncidenciaDefault = {
        codUrgencia: 0,
        comentarioAtencion: "",
        codIncidenciaConcepto: 0,
        solucionado: false,
        codIncidenciaTipoCierre: 0,
        comentarioCierre: "",
        motivoIncidencia: ""
    }

    const derivarIncidenciaDefault = {
        codAreaDestino : 0,
        comentarioDerivacionDestino: ''
    }

    const resolverIncidenciaDefault = {
        fechaHoraInicioAtencion: "",
        uidSolucionConcatenado: "",
        causaIncidencia: "",
        comentarioSolucion: "",
        segundosTotalAtencion: 0,
    }

    const cierreIncidenciaDefault = {
        comentarioCierre: "",
        codIncidenciaTipoCierre: 0,
        codIncidenciaConcepto: 0,
    }

    const [ loading, setLoading ] = useState(false)
    const [ incidencias, setIncidencias ] = useState([]); // Listado de incidencias
    const [ procesosIncidencia, setProcesosIncidencia ] = useState([]);
    const [ tipoCierreIncidencia, setTipoCierreIncidencia ] = useState([]);
    const [ tipoUrgencia, setTipoUrgencia ] = useState([])
    const [ incidenciaPGI, setRegistroIncidencia ] = useState(incidenciaDefault);
    const [ detalleIncidencia, setDetalleIncidencia ] = useState(detalleDefault);
    const [ imagenesTgps, setImagenesTgps ] = useState([]);
    const [ validarIncidencia, setValidarIncidencia ] = useState(validarIncidenciaDefault);
    const [ imagenesValidacion, setImagenesValidacion ] = useState([]);
    const [ documentosValidacion, setDocumentosValidacion ] = useState([])
    const [ derivarIncidencia, setDerivarIncidencia ] = useState(derivarIncidenciaDefault);
    const [ resolverIncidencia, setResolverIncidencia ] = useState(resolverIncidenciaDefault)
    const [ cierreIncidencia, setCierreIncidencia ] = useState(cierreIncidenciaDefault)
    const [ imagenesCierre, setImagenesCierre ] = useState([]);
    const [ documentosCierre, setDocumentosCierre ] = useState([]);
    const [ seguimientoIncidencia, setSeguimientoIncidencia ] = useState([])
    const [ comentarioSeguimiento, setComentarioSeguimiento ] = useState('')
    const [ unidades, setUnidades ] = useState([]);

    
    const listarIncidencias = async (codigoEstado, fechaInicio, fechaFin) => {
        setLoading(true)
        try{
            const response = await Fetch({
                url: urlIncidencias + '?' + new URLSearchParams({
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin,
                    CodEstado: codigoEstado || 0,
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setIncidencias(response.isValid ? response.content : []);
            setLoading(false)
        }
        catch(error){
            setIncidencias([]);
            notify('Ocurrió un error: ' + error,'error');
            setLoading(false)
        }
    }

    const listarProcesosIncidencia = async () => {
        try{
            const response = await Fetch({ url: urlIncidenciaProcesos });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setProcesosIncidencia(response.isValid ? response.content : []);
        }
        catch(error){
            setProcesosIncidencia([]);
            notify('Ocurrió un error: ' + error,'error');
        }
    }

    const resetIncidenciaPGI = () => {
        setRegistroIncidencia(incidenciaDefault)
    }

    const editarValorRegistroIncidencia = async (key,value) =>{
        setRegistroIncidencia(indicencia => {
            return {
                ...indicencia,
                [key]: value
            }
        });
    }

    const obtenerDetalleIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidencias + '/detail?'+ new URLSearchParams({
                    CodIncidencia : codIncidencia,
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            if(response.isValid){
                response.content.detalleIncidencia.codIncidencia = codIncidencia;
                setDetalleIncidencia(response.content.detalleIncidencia);
                setImagenesTgps(response.content.detalleIncidencia.listaImagenesTgps || [] );
                setValidarIncidencia(response.content.validacionIncidencia);
                setImagenesValidacion(response.content.validacionIncidencia.listaImagenesValidacion || []);
                setDocumentosValidacion(response.content.validacionIncidencia.listaDocumentosValidacion || []);
                setDerivarIncidencia(response.content.derivacionIncidencia);
                setResolverIncidencia(response.content.resolucionIncidencia|| resolverIncidenciaDefault);
                setCierreIncidencia(response.content.cierreIncidencia|| cierreIncidenciaDefault);
                setImagenesCierre(response.content.cierreIncidencia.listaImagenesCierre || []);
                setDocumentosCierre(response.content.cierreIncidencia.listaDocumentosCierre || []);
            }
            else{
                setDetalleIncidencia(detalleDefault);
                setImagenesTgps([]);
                setValidarIncidencia(validarIncidenciaDefault);
                setDerivarIncidencia(derivarIncidenciaDefault);
                setResolverIncidencia(resolverIncidenciaDefault);
                setCierreIncidencia(cierreIncidenciaDefault);
                setImagenesCierre([]);
                setDocumentosCierre([]);
            }
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al obtener incidencia: ', error);
            setDetalleIncidencia(detalleDefault);
        }
    }

    const guardarIncidenciaPGI = async (urlArchivo) => {
        try{
            const response = await Fetch({
                url: urlIncidencias + '/pgi',
                method:"POST",
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0] ,
                    tituloIncidencia: incidenciaPGI.tituloIncidencia,
                    descripcionIncidencia: incidenciaPGI.descripcionIncidencia,
                    codProductoInterno: incidenciaPGI.codProductoInterno,
                    codEmpresaGeneral: incidenciaPGI.codEmpresaGeneral,
                    codUnidad: incidenciaPGI.codUnidad,
                    padronUnidad: incidenciaPGI.padronUnidad,
                    placaUnidad: incidenciaPGI.placaUnidad,
                    codAreaDestino: incidenciaPGI.codAreaDestino,
                    codIncidenciaConcepto: incidenciaPGI.codIncidenciaConcepto,
                    codUrgencia: incidenciaPGI.codUrgencia,
                    solucionado: incidenciaPGI.solucionado ? 1 : 0,
                    codIncidenciaTipoCierre: incidenciaPGI.codIncidenciaTipoCierre,
                    comentarioSolucion: incidenciaPGI.comentarioSolucion,
                    dataArchivo: urlArchivo.length > 0 ? urlArchivo : []
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'));
            return response.isValid;
        }
        catch(error){
            console.log('error ',error)
            notify('Ocurrió un error en el servicio','error');
            return false;
        }
    }

    const listarTipoCierre = async () => {
        try{
            const response = await Fetch({url: urlIncidenciaGeneral + '/closureType'});
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setTipoCierreIncidencia(response.isValid ? response.content : []);
        }
        catch(error){
            setTipoCierreIncidencia([]);
            notify('Ocurrió un error: ' + error,'error');
        }
    }

    const listarTipoUrgencia = async () => {
        try{
            const response = await Fetch({url: urlIncidenciaGeneral + '/typeEmergency'});
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setTipoUrgencia(response.isValid ? response.content : []);
        }
        catch(error){
            setTipoUrgencia([]);
            notify('Ocurrió un error: ' + error,'error');
        }
    }

    const listaSeguimientoIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaSeguimiento + '?'+ new URLSearchParams({
                    CodIncidencia : codIncidencia,
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setSeguimientoIncidencia(response.isValid ? response.content : []);
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al obtener incidencia: ', error);
            setSeguimientoIncidencia([]);
        }
    }

    const listarUnidadesPorEmpresa = async (codEmpresa) => {
        try{
            const response = await Fetch({url: urlIncidenciaGeneral + '/unitsByCompanie?' + new URLSearchParams({
                CodEmpresa: codEmpresa
            })});
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setUnidades(response.isValid ? response.content : []);
        }
        catch(error){
            setUnidades([]);
            notify('Ocurrió un error: ' + error,'error');
        }
    }

    const resetUnidades = () => {
        setUnidades([])
    }

    // {/* PROCESO DE CADA INCIDENCIA */}
    // const listarValidacionIncidencia = async (codIncidenciaEmpresa, codIncidencia) => {

    const editarValorValidacion = (key,value) => {
        setValidarIncidencia(prev => {
            return {
                ...prev,
                [key]: value
            }
        });
    }

    const editarValorDerivacion = (key,value) => {
        setDerivarIncidencia(prev => {
            return {
                ...prev,
                [key]: value
            }
        });
    }
    
    const editarValorCierre = (key,value) => {
        setCierreIncidencia(prev => {
            return {
                ...prev,
                [key]: value
            }
        });
    }
    
    const editarValorResolucion = (key,value) => {
        setResolverIncidencia(prev => {
            return {
                ...prev,
                [key]: value
            }
        });
    }

    const guardarValidacionIncidencia = async (codIncidencia, urlArchivo) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaProcesos + '/registerValidation',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia,
                    codUrgencia: validarIncidencia.codUrgencia,
                    comentario: validarIncidencia.comentarioAtencion,
                    codIncidenciaConcepto: validarIncidencia.codIncidenciaConcepto,
                    solucionado: validarIncidencia.solucionado ? 1 : 0,
                    codIncidenciaTipoCierre: validarIncidencia.codIncidenciaTipoCierre,
                    motivoIncidencia: validarIncidencia.motivoIncidencia,
                    dataArchivosValidacion: urlArchivo.length >  0 ? urlArchivo : []
                })
            });
            notify((response.isValid  ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const guardarDerivacionIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaProcesos + '/registerDerivation',
                method: 'PUT',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codIncidencia: codIncidencia,
                    codAreaDestino: derivarIncidencia.codAreaDestino,
                    comentarioDerivacionDestino: derivarIncidencia.comentarioDerivacionDestino,
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                })
            });
            notify((response.isValid  ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    const guardarParticipantes = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciasXproject + '/assignParticipants',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    uidSolucion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description),response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al asignar participantes: ',e)
            return false;
        }
    }
    
    const guardarCierreIncidencia = async (codIncidencia, urlArchivo) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaProcesos + '/registerClosure',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia,
                    comentarioCierre: cierreIncidencia.comentarioCierre,
                    codIncidenciaTipoCierre: cierreIncidencia.codIncidenciaTipoCierre,
                    codIncidenciaConcepto: cierreIncidencia.codIncidenciaConcepto,
                    dataArchivosCierre: urlArchivo.length > 0 ? urlArchivo : []
                })
            });
            notify((response.isValid  ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }
    
    const guardarSeguimientoIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaSeguimiento,
                method: 'POST',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia,
                    comentario: comentarioSeguimiento,
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }
    
    const eliminarSeguimientoIncidencia = async (codIncidenciaSeguimiento)  => {
        try{
            const response = await Fetch({
                url: urlIncidenciaSeguimiento,
                method: 'DELETE',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidenciaSeguimiento: codIncidenciaSeguimiento,
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
        
    }

    const guardarSolucionIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaProcesos + '/registerSolution',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia,
                    causaIncidencia: resolverIncidencia.causaIncidencia,
                    comentarioSolucion: resolverIncidencia.comentarioSolucion,
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description) , (response.isValid ? 'success' : 'error'))
            return response.isValid;
        }
        catch(error){
            console.log('Error al guardar validación: ', error);
            notify('Ocurrió un error en el servicio', 'error');
            return false;
        }
    }

    
    return {
        incidencias,
        listarIncidencias,
        listarProcesosIncidencia,
        procesosIncidencia,
        incidenciaPGI,
        editarValorRegistroIncidencia,
        resetIncidenciaPGI,
        guardarIncidenciaPGI,
        obtenerDetalleIncidencia,
        detalleIncidencia,
        imagenesTgps,
        validarIncidencia,
        imagenesValidacion,
        documentosValidacion,
        editarValorValidacion,
        guardarValidacionIncidencia,
        guardarDerivacionIncidencia,
        guardarSolucionIncidencia,
        derivarIncidencia,
        editarValorDerivacion,
        resolverIncidencia,
        editarValorResolucion,
        cierreIncidencia,
        editarValorCierre,
        imagenesCierre,
        documentosCierre,
        guardarCierreIncidencia,
        listarTipoCierre,
        tipoCierreIncidencia,
        listarTipoUrgencia,
        tipoUrgencia,
        listaSeguimientoIncidencia,
        seguimientoIncidencia,
        setComentarioSeguimiento,
        comentarioSeguimiento,
        guardarSeguimientoIncidencia,
        guardarParticipantes,
        listarUnidadesPorEmpresa,
        unidades,
        resetUnidades,
        eliminarSeguimientoIncidencia,
        loading
    };
}